import { CombinedState, configureStore } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga'

import { rootReducer } from './rootReducer'
import { RootSaga } from './rootSaga'
import type { GlobalState } from './types'

const initialGlobalState: GlobalState = {
  claim: {
    requesting: false,
    valid: true,
    claimDetails: {
      claim: '',
      dateOfLoss: '',
      professionals: [],
      lob: ''
    },
    disableInputs: false
  },
  notifications: {
    notifications: []
  },
  upload: {
    requesting: false,
    success: false,
    finished: false,
    progress: 0,
    files: [],
    hideCategories: [],
    errors: [],
    category: '',
    trackingError: false,
    sourceSystem: '',
    handler: ''
  },
  uploadErrors: [],
  form: {}
}

const sagaMiddleware = createSagaMiddleware()

const store = configureStore<CombinedState<GlobalState>>({
  reducer: rootReducer,
  middleware: [sagaMiddleware]
})

// We use dispatch in our upload saga, but we don't want to import
// the store in the saga because that will cause an import cycle, so we inject
// dispatch into the root saga to pass onto the upload saga.
sagaMiddleware.run(RootSaga.bind(null, store.dispatch))

export { initialGlobalState, store }
